import { post } from "./fetch.core";
import { AddOnDiscountGroup } from "../types/cart";
import { TransMsg } from "../i18n/messages";

export async function listAddOnProductsCart(productIds: string[], cartId: string): Promise<AddOnDiscountGroup[]> {
  const res = await post<AddOnDiscountGroup[]>("/public/addOnDiscount/list", {
    productIds,
    cartId,
    placeAt: "checkout",
  });

  if (res.status === 200 && res.data) {
    return res.data;
  }

  return [];
}

export function handleAddOnError(error: any, t: (msg: TransMsg) => string, msg: any): string {
  const errorMessage = error?.response?.data?.message || error?.message;

  switch (errorMessage) {
    case "maxQuantityReached":
      const maxQty = error?.response?.data?.maxQuantity || 0;
      return t(msg.addOnDiscount.maxQuantityReached).replace("{quantity}", maxQty.toString());

    case "maxQuantityExceeded":
      const remaining = error?.response?.data?.remainingQuantity || 0;
      return t(msg.addOnDiscount.maxQuantityExceeded).replace("{quantity}", remaining.toString());

    case "tierThresholdNotMet":
      return t(msg.addOnDiscount.tierThresholdNotMet);

    case "linkProductNotExists":
      return t(msg.addOnDiscount.linkProductNotExists);

    case "productNotInAddOnItems":
      return t(msg.addOnDiscount.productNotEligible);

    case "cannotFindValidShippingForAllItems":
      return t(msg.addOnDiscount.shippingConflict);

    case "addOnDiscountNotFound":
      return t(msg.addOnDiscount.discountNotFound);

    case "productNotFound":
      return t(msg.addOnDiscount.productNotFound);

    case "cartNotFound":
      return t(msg.errors.cartNotFound);

    default:
      return t(msg.general.errSubmit);
  }
}
